import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { SectionCta } from './SectionCta';
export function GuaranteeSection() {
  return <section className="w-full bg-navy py-16 sm:py-24" aria-labelledby="guarantee-title" data-id="element-152" data-mp="4vjnw74ptag7">
      <div className="mx-auto max-w-4xl px-4 sm:px-6" data-id="element-153" data-mp="9srwbg02a049">
        <div className="flex flex-col items-center gap-6 text-center md:flex-row md:text-left" data-id="element-154" data-mp="etz3bcudqv9v">
          <div className="flex h-36 w-36 shrink-0 flex-col items-center justify-center rounded-full border-4 border-volt bg-ink" data-id="element-155" data-mp="jsslhikm3agd">
            <ShieldCheckIcon className="h-10 w-10 text-volt" aria-hidden="true" data-id="element-156" data-mp="nst83qhv6ryi" />
            <span className="font-display text-3xl font-extrabold leading-none text-white" data-id="element-157" data-mp="skknd4vklb9c">7-DAY</span>
            <span className="text-[11px] font-bold uppercase tracking-wider text-mist" data-id="element-158" data-mp="xk72xkyvf3lb">Guarantee</span>
          </div>
          <div data-id="element-159" data-mp="12kbhv6k4rq9f">
            <p className="font-display text-lg font-bold uppercase tracking-wider text-spark" data-id="element-160" data-mp="12kv1qstccoq3">
              Your purchase is protected
            </p>
            <h2 id="guarantee-title" className="mt-1 font-display text-4xl font-extrabold uppercase leading-none text-white sm:text-5xl" data-id="element-161" data-mp="25sgifflb2a1e">
              7-Day Money-Back Guarantee
            </h2>
            <p className="mt-4 text-base leading-relaxed text-mist sm:text-lg" data-id="element-162" data-mp="1vu9cdrsk1ce6">
              Explore the Automotive Parasitic Drain Diagnostic Blueprint™ and review the included workflows,
              checklists, and documentation tools. If the product doesn’t meet your expectations, you can request
              a refund within seven days of purchase, subject to the stated refund policy.
            </p>
          </div>
        </div>

        <SectionCta label="Try it risk-free for 7 days" data-id="element-163" data-mp="2ar037co5xfs6" />
      </div>
    </section>;
}